import { Skeleton, Stack } from '@mui/material';

export const ToniAILoadingIndicator = () => {
  return (
    <Stack direction="row" gap="0.125rem">
      {[1, 2, 3].map(() => (
        <Skeleton
          variant="circular"
          width="0.5rem"
          height="0.5rem"
          style={{ background: 'var(--ui05)' }}
        />
      ))}
    </Stack>
  );
};
